import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/sharedOffice/spaceList',
    name: 'sharedOfficeSpaceList',
    component: () => import('@/sub-app/sharedOffice/pages/spaceList.vue'),
    meta: {
      title: '共享办公',
      keepAlive: false,
    },
  },
  {
    path: '/sharedOffice/spaceDetails',
    name: 'sharedOfficeSpaceDetails',
    component: () => import('@/sub-app/sharedOffice/components/spaceDetails.vue'),
    meta: {
      title: '共享空间详情',
      keepAlive: false,
    },
  },
  // 添加时间选择
  {
    path: '/sharedOffice/spaceBalance',
    name: 'sharedOfficeSpaceBalance',
    component: () => import('@/sub-app/sharedOffice/components/spaceBalance.vue'),
    meta: {
      title: '共享办公',
      keepAlive: false,
    },
  },
  // 确认订单页面
  {
    path: '/sharedOffice/spaceConfirmOrder',
    name: 'sharedOfficeSpaceConfirmOrder',
    component: () => import('@/sub-app/sharedOffice/components/spaceConfirmOrder.vue'),
    meta: {
      title: '确认订单',
      keepAlive: false,
    },
  },
  // 我的页面
  {
    path: '/sharedOffice/myOrderList',
    name: 'sharedOfficeMyOrderList',
    component: () => import('@/sub-app/sharedOffice/pages/myOrderList.vue'),
    meta: {
      title: '我的订单',
      keepAlive: false,
    },
  },
  // 订单详情页面
  {
    path: '/sharedOffice/spaceOrderDetails',
    name: 'sharedOfficeSpaceOrderDetails',
    component: () => import('@/sub-app/sharedOffice/components/spaceOrderDetails.vue'),
    meta: {
      title: '订单详情',
      keepAlive: false,
    },
  },
  // 空间预定管理页面
  {
    path: '/sharedOffice/spaceReservatManage',
    name: 'sharedOfficeSpaceReservatManage',
    component: () => import('@/sub-app/sharedOffice/pages/spaceReservatManage.vue'),
    meta: {
      title: '空间预定管理',
      keepAlive: false,
    },
  },
  // 审核订单页面
  {
    path: '/sharedOffice/reviewOrderPage',
    name: 'sharedOfficereviewOrderPage',
    component: () => import('@/sub-app/sharedOffice/components/reviewOrder.vue'),
    meta: {
      title: '审核订单',
      keepAlive: false,
    },
  },
  // 审核订单详情页面
  {
    path: '/sharedOffice/reviewOrderDetails',
    name: 'sharedOfficeReviewOrderDetails',
    component: () => import('@/sub-app/sharedOffice/components/reviewOrderDetails.vue'),
    meta: {
      title: '订单详情',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  document.title = to.meta?.title || '';
  next();
});

export default router;
